import { lazy, Suspense, useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Header from '../components/header/header.component'

import './App.scss'

const CespitiPage = lazy(() => import('../pages/cespiti-menu/cespiti.page'))
const AuthPage = lazy(() => import('../pages/auth/auth.page'))
const ContiPage = lazy(() => import('../pages/conti/conti.page'))
const CespitePage = lazy(() => import('../pages/cespite/cespite.page'))
const FornitoriPage = lazy(() => import('../pages/fornitori/fornitori.page'))
const ValidationPage = lazy(() => import('../pages/validation/validation.page'))
const AddolcitorePage = lazy(() => import('../pages/addolcitore/addolcitore.page'))
const HomePage = lazy(() => import('../pages/home/home.page'))
const ProfilePage = lazy(() => import('../pages/profile/profile.page'))
const InformativaPrivacyPage = lazy(() => import('../pages/informativa-privacy/informativa-privacy.page'))

const App = () => {
  const { active } = useSelector(state => state.user)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if(!pathname.includes('/validate') && !pathname.includes('/informativa-privacy') && !active)
      navigate('/auth', { replace: true })
  }, [navigate, active, pathname])

  return (
    <div className='app'>
      <Header />
      <Suspense fallback={<span>Loading...</span>}>
        <Routes>
          <Route exact path='/addolcitore' element={<AddolcitorePage />} /> 
          <Route exact path='/' element={<HomePage />} />  
          <Route exact path='*' element={<span>Page not found</span>} />     
          <Route exact path='/auth' element={<AuthPage />} />    
          <Route exact path='/profile' element={<ProfilePage />} /> 
          <Route exact path='/informativa-privacy' element={<InformativaPrivacyPage />} /> 
          <Route exact path='validate/:uId' element={<ValidationPage />} /> {/*     
          <Route exact path='/cespiti' element={<CespitiPage />} />  
          <Route exact path='/fornitori' element={<FornitoriPage />} />  
          <Route exact path='/conti' element={<ContiPage />} />   
          <Route exact path='/cespiti/item/:id' element={<CespitePage />} />  */}   
        </Routes>
      </Suspense>
    </div>
  )
}

export default App
